import { injectable } from 'inversify';
import { TypeLvl } from '@Models';
import { profil_type_lvls } from '@Api';

@injectable()
export class TypeLvlMapper {
  public map(item: profil_type_lvls): TypeLvl {
    switch (item) {
      case profil_type_lvls.DEFENSIVE:
        return TypeLvl.Defensive;
      case profil_type_lvls.OFFENSIVE:
        return TypeLvl.Offensive;
      case profil_type_lvls.ARMY:
        return TypeLvl.Army;
    }

    return TypeLvl.Global;
  }

  mapDto(item: TypeLvl): profil_type_lvls {
    switch (item) {
      case TypeLvl.Defensive:
        return profil_type_lvls.DEFENSIVE;
      case TypeLvl.Offensive:
        return profil_type_lvls.OFFENSIVE;
      case TypeLvl.Army:
        return profil_type_lvls.ARMY;
    }

    return profil_type_lvls.GLOBAL;
  }
}
